import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class ReportInvoices extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.invoicesList.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th className="hidden-md-down">VendorName</th>
                <th className="hidden-xlg-down">DateDue</th>
                <th className="hidden-xs-down">InvNum</th>
                <th className="hidden-md-down">Date</th>
                <th>ItemDesc</th>
                <th className="hidden-xs-down">Cost</th>
                <th className="hidden-xlg-down">Pack</th>
                <th className="hidden-xlg-down">Qty</th>
                <th className="hidden-sm-down">TotalQty</th>
                <th className="hidden-sm-down">NetWeight</th>
                <th>TotalPrice</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.props.invoicesList.map((i, idx) => {
                return (
                  <tr key={idx}>
                    <td className="hidden-md-down">{ i.vendor_name} </td>
                    <td className="hidden-xlg-down">{ i.due_date } </td>
                    <td className="hidden-xs-down">{ i.invoice_number} </td>
                    <td className="hidden-md-down">{ i.date } </td>
                    <td className="text-ellipsis-xxs-down"> { i.item_description}</td>
                    <td className="hidden-xs-down">{ i.cost} </td>
                    <td className="hidden-xlg-down">{ i.pack} </td>
                    <td className="hidden-xlg-down">{ parseFloat(i.quantity.toFixed(2)) } </td>
                    <td>{ i.total_quantity} </td>
                    <td className="hidden-sm-down">{ parseFloat(i.net_weight.toFixed(2)) } </td>
                    <td className="hidden-sm-down">{ parseFloat(i.total_price.toFixed(2)) } </td>
                    <td>
                    <NavLink className="btn-sm btn-info" to={`/invoice/${i.invoice}/`}>
                        <i className="fa fa-eye"></i>
                    </NavLink>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
